var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRaclogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.843,
    height: 42.754,
    viewBox: "0 0 130.843 42.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RAC_LOGO",
    "data-name": "RAC LOGO",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6292",
    "data-name": "Group 6292",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25010",
    "data-name": "Path 25010",
    d: "M341.545,496.482A21.373,21.373,0,0,0,322.3,521.018a3.94,3.94,0,0,0,5.557,2.994l.083-.039a3.879,3.879,0,0,0,2.235-4.084,13.423,13.423,0,1,1,10.4,11.006,3.971,3.971,0,0,0-4.05,1.528h0a3.976,3.976,0,0,0,2.329,6.236,21.379,21.379,0,1,0,2.691-42.178Z",
    transform: "translate(-322.055 -496.4)",
    fill: "#165b8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25011",
    "data-name": "Path 25011",
    d: "M341.561,496.482A21.425,21.425,0,0,0,322.2,515.389c-.057.521-.092,1.038-.112,1.552a18.6,18.6,0,1,1,25.316,21.849,21.38,21.38,0,0,0-5.845-42.308Z",
    transform: "translate(-322.071 -496.4)",
    fill: "#1799d6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2496",
    "data-name": "Ellipse 2496",
    cx: 9.145,
    cy: 9.145,
    r: 9.145,
    transform: "translate(12.242 12.05)",
    fill: "#d73832"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6293",
    "data-name": "Group 6293",
    transform: "translate(51.199 13.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25012",
    "data-name": "Path 25012",
    d: "M417.979,529.388v5.6h-3.093V520.4h4.251a7.274,7.274,0,0,1,4.4,1.083,4.317,4.317,0,0,1,.719,5.578,4.689,4.689,0,0,1-2.006,1.571q3.293,4.92,4.291,6.356h-3.433l-3.482-5.6Zm0-2.514h1a3.818,3.818,0,0,0,2.165-.489,1.746,1.746,0,0,0,.7-1.537,1.6,1.6,0,0,0-.714-1.477,4.332,4.332,0,0,0-2.21-.439h-.938Z",
    transform: "translate(-414.886 -520.188)",
    fill: "#1799d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25013",
    "data-name": "Path 25013",
    d: "M446.783,534.938l-1.057-3.472h-5.318l-1.058,3.472h-3.332l5.149-14.648h3.781l5.169,14.648Zm-1.8-6.067q-1.467-4.719-1.651-5.338t-.265-.978q-.329,1.277-1.886,6.316Z",
    transform: "translate(-424.363 -520.14)",
    fill: "#1799d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25014",
    "data-name": "Path 25014",
    d: "M470.578,522.593a3.153,3.153,0,0,0-2.7,1.312,6.106,6.106,0,0,0-.957,3.657q0,4.879,3.662,4.879a11.57,11.57,0,0,0,3.722-.768v2.594a10.336,10.336,0,0,1-4.011.748,6.117,6.117,0,0,1-4.869-1.93,8.174,8.174,0,0,1-1.687-5.543,9.049,9.049,0,0,1,.828-3.986,5.988,5.988,0,0,1,2.38-2.625,7.043,7.043,0,0,1,3.637-.913,9.827,9.827,0,0,1,4.271,1.028l-1,2.514a16.6,16.6,0,0,0-1.647-.678A4.921,4.921,0,0,0,470.578,522.593Z",
    transform: "translate(-436.792 -520.018)",
    fill: "#1799d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25015",
    "data-name": "Path 25015",
    d: "M498.6,524.948a4.46,4.46,0,0,1-1.472,3.6,6.293,6.293,0,0,1-4.186,1.247h-1.327v5.189h-3.093V520.4h4.659a6.2,6.2,0,0,1,4.036,1.142A4.168,4.168,0,0,1,498.6,524.948Zm-6.985,2.315h1.018a3.393,3.393,0,0,0,2.136-.564,1.973,1.973,0,0,0,.708-1.641,2.024,2.024,0,0,0-.593-1.607,2.783,2.783,0,0,0-1.861-.519h-1.407Z",
    transform: "translate(-447.908 -520.188)",
    fill: "#1799d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25016",
    "data-name": "Path 25016",
    d: "M519.22,534.938l-1.058-3.472h-5.318l-1.057,3.472h-3.333L513.6,520.29h3.782l5.169,14.648Zm-1.8-6.067q-1.468-4.719-1.651-5.338t-.265-.978q-.329,1.277-1.886,6.316Z",
    transform: "translate(-456.848 -520.14)",
    fill: "#1799d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25017",
    "data-name": "Path 25017",
    d: "M549.45,527.552a7.182,7.182,0,0,1-2.051,5.518,8.36,8.36,0,0,1-5.922,1.916h-4.13V520.4h4.579a7.713,7.713,0,0,1,5.548,1.886A6.936,6.936,0,0,1,549.45,527.552Zm-3.213.079q0-4.7-4.151-4.7H540.44v9.5h1.327Q546.237,532.431,546.237,527.632Z",
    transform: "translate(-469.806 -520.188)",
    fill: "#1799d6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaclogo);
export default __webpack_public_path__ + "static/media/RAC LOGO.8653af8e.svg";
export { ForwardRef as ReactComponent };